var Enum = Enum || {};

Enum.MEEDY.SECOND_DIAGNOSIS_REJECTION_HISTORY_TYPE = {
  CONSULTANT: 'CONSULTANT',
  PATIENT: 'PATIENT',
  PHYSICIAN: 'PHYSICIAN'
};

Object.freeze(Enum.MEEDY.SECOND_DIAGNOSIS_REJECTION_HISTORY_TYPE);